const types = {
    SET_TRAINING_GUIDES_DATA : 'SET_TRAINING_GUIDES_DATA'
  }

  export default types;
